import React, { useEffect } from 'react';
import { observer, inject } from 'mobx-react';
import './style/main.less';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import StepNew from './StepNew';

const Main = inject('stepStore')(observer((props: any) => {
  useEffect(() => {
    return () => {
      props.stepStore.reset()
    }
    // eslint-disable-next-line
  }, [])

  const StepItem = ({index, title}: { index: number, title: string }) => (
    <div className={`step-item ${index <= props.stepStore.currentStep ? 'active' : ''}`}>
      <span>{index}</span>
      <span>{title}</span>
    </div>
  )

  const Step = () => (
    <div className='step'>
      <StepItem index={1} title='填写基本资料'/>
      <StepItem index={2} title='填写联系方式'/>
      <StepItem index={3} title='完成入驻申请'/>
    </div>
  )

  const renderContent = () => {
    switch (props.stepStore.currentStep) {
      case 1:
        return <StepNew stepStore={props.stepStore}/>;
      case 2:
        return <Step2/>;
      case 3:
        return <Step3/>;
    }
  }

  return (
    <section className='settled-main'>
      {/* <Step/> */}
      <div>
        {renderContent()}
      </div>
    </section>
  )
}))

export default Main;


// const MainStyle = styled.div`
//   vertical-align: top;
//   display: inline-block;
//   width: 950px;
//   margin: 0 auto;
// `